// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"be6975c2","560":"6ff97574","649":"a7ac80ed","697":"d7dc9715","910":"27cab88a","922":"cbda40f1"}[chunkId] + ".chunk.js";
};